/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcdms.vcprinter')
    .component('printerform', {
      restrict: 'E',
      bindings: {
        printer: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcdms/vcprinterform-component.tpl.html',
      controllerAs: 'vm',
      controller:
        function () {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;

          vm.$onInit = function () {
            vm.lastprinter = angular.copy(vm.printer);
          };
          
          function save() {
            if (!angular.equals(vm.printer, vm.lastprinter)) {
              vm.lastprinter = angular.copy(vm.printer);
              vm.parentsave({printer: vm.printer});
            }
          }
          
          function cancel() {
            vm.printer = angular.copy(vm.lastprinter);
            vm.oncancel();
          }

        }// controller
    }); // component

// klammerfriedhof
}());
